export default __webpack_public_path__ + "static/media/castagne-di-martorana-preview.847dcdbe.pdf";